import Card from 'components/card';

const DeletePurchase = (props: {
    isOpen: any;
    onClose: any;
    description: any;
    context: string;
    deleteFunction: any;
}) => {
    const { isOpen, onClose, description, context, deleteFunction } = props;

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-[20000] flex items-center justify-center p-4">
            <div 
                className="absolute inset-0 bg-black/50 backdrop-blur-sm" 
                onClick={onClose} 
            />
            <div className="relative w-full max-w-[650px]">
                <Card extra="px-[30px] pt-[35px] pb-[40px] flex flex-col">
                    <h1 className="mb-[20px] text-2xl font-bold">
                        Suppression {context}
                    </h1>
                    <p>{description}</p>
                    <div className="mt-5 flex gap-2 mx-auto">
                        <button
                            onClick={onClose}
                            className="linear rounded-xl border-2 border-gray-700 px-5 py-3 text-base font-medium text-gray-700 transition duration-200 hover:bg-red-600/5 active:bg-red-700/5 dark:border-red-400 dark:bg-red-400/10 dark:text-white dark:hover:bg-red-300/10 dark:active:bg-red-200/10"
                        >
                            Annuler
                        </button>
                        <button
                            className="linear hover:bg-red600 col-span-12 ml-3 flex items-center justify-center rounded-xl bg-red-500 px-3 py-3 text-base font-medium text-white active:bg-red-700 sm:col-span-6 lg:col-span-4 xl:col-span-3 xl:col-start-12"
                            onClick={deleteFunction}
                        >
                            Supprimer définitivement
                        </button>
                    </div>
                </Card>
            </div>
        </div>
    );
};

export default DeletePurchase;
